import React from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import ClickableTableCell from '../shared/ClickableTableCell';
import { useTranslation } from 'react-i18next';
import { employeeStatusOptions, translateOptionValue } from '../../exl/shared/translations';

const TableCell = ({ row, column, ...restProps }) => {
    const { t } = useTranslation(['shared']);

    const columnName = column.name;

    if (columnName === 'name' || columnName === 'boss' || columnName === 'office') {
        let href;
        if (columnName === 'name') href = `/employee/${row.id}/info`;
        else if (columnName === 'boss') href = `/employee/${row.bosEmpID}/info`;
        else href = `/office/${row.officeId}`;

        return <ClickableTableCell href={href} showText={row[columnName]} />;
    } else if (columnName === 'hours') {
        const hasDecimals = (row.hours || 0) % 1 !== 0;
        let classes = 'hours';
        if (hasDecimals) {
            classes += ' padding-right-none';
        }
        return (
            <Table.Cell {...restProps} className={classes}>
                <div className='d-flex align-items-center h-100'>{row[columnName]}</div>
            </Table.Cell>
        );
    } else if (columnName === "status") {
        return (
            <Table.Cell {...restProps}>
                <div className='d-flex align-items-center h-100'>{t(translateOptionValue(row[columnName], employeeStatusOptions))}</div>
            </Table.Cell>
        );
    }

    return (
        <Table.Cell {...restProps}>
            <div className='d-flex align-items-center h-100'>{row[columnName]}</div>
        </Table.Cell>
    );
};

export default TableCell;
